import { FC, PropsWithChildren, createContext, useContext } from 'react'

import { UseHSTableReturnType } from 'features/ContractDetails/Facilities/hooks/useHSTable'
import { defaultHSTable } from './constants'

type ContextProps = UseHSTableReturnType

const HSTableContext = createContext<ContextProps>(defaultHSTable)

const HSTableProvider: FC<PropsWithChildren & ContextProps> = (props) => {
  const { children, ...contextValueProps } = props

  return (
    <HSTableContext.Provider value={contextValueProps}>
      {children}
    </HSTableContext.Provider>
  )
}

export const useHSTableContext = () => useContext(HSTableContext)

export default HSTableProvider
